(() => {
  if (window.__ksManagedFormsLoaded) return;
  window.__ksManagedFormsLoaded = true;

  const statusClass = (container, error) => {
    if (container.dataset.ksFormStyle === 'dawn') return 'form-status form-status-list form__message';
    return container.classList.contains('ks-df')
      ? `ks-df__note ${error ? 'ks-df__note--err' : 'ks-df__note--ok'}`
      : `ks-contact__status${error ? ' ks-contact__status--error' : ''}`;
  };

  function showStatus(container, form, message, error) {
    let status = container.querySelector('[data-ks-form-status]');
    if (!status) {
      status = document.createElement('div');
      status.dataset.ksFormStatus = '';
      status.setAttribute('role', error ? 'alert' : 'status');
      const grid = form.querySelector('.ks-df__grid');
      (grid || form).prepend(status);
    }
    status.className = statusClass(container, error);
    status.textContent = message;
    status.tabIndex = -1;
    status.focus();
  }

  async function submit(container, form) {
    const button = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    const fields = {};
    for (const [name, value] of data.entries()) {
      const match = name.match(/^contact\[([^\]]+)\]$/);
      if (match && typeof value === 'string') fields[match[1]] = value;
    }
    button?.setAttribute('disabled', 'disabled');
    try {
      const response = await fetch('/apps/ks-core/forms', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          formId: container.dataset.ksFormType,
          fields,
          website: data.get('website') || '',
          pageUrl: window.location.href,
        }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) throw new Error(result.error || 'We could not send your request. Please try again.');
      form.reset();
      showStatus(container, form, result.message || container.dataset.ksSuccess || 'Thank you. Your request was sent.', false);
    } catch (error) {
      showStatus(container, form, error instanceof Error ? error.message : 'We could not send your request. Please try again.', true);
    } finally {
      button?.removeAttribute('disabled');
    }
  }

  function connect(container) {
    if (container.dataset.ksFormConnected === 'true') return;
    const form = container.querySelector('form');
    if (!form) return;
    container.dataset.ksFormConnected = 'true';
    form.addEventListener('submit', (event) => {
      if (!form.reportValidity()) return;
      event.preventDefault();
      submit(container, form);
    });
  }

  function init() { document.querySelectorAll('[data-ks-form-type]').forEach(connect); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
